import {useCallback, useState} from 'react'

import {usePipelineId} from '../../../../../hooks/pipeline'

import {pipelineDraft} from 'src/components/pages/PipelinesPages/EditPipelinePage/slices/EditPipelinePage.slices'
import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

function usePipelineSecret(name: string) {
  const dispatch = useAppDispatch()
  const id = usePipelineId()
  const [isEditMode, setEditMode] = useState(false)
  const renamedSecrets = useAppSelector(
    state => state.pipelines.pipelineDraft[id]?.renamed?.secrets,
  )
  const getActualName = useCallback((key: string) => renamedSecrets?.[key] ?? key, [renamedSecrets])
  const secretName = getActualName(name)
  const handlerSecretDeleteButtonClick = () => {
    dispatch(pipelineDraft.actions.deleteSecret({id, name}))
    setEditMode(false)
  }
  const handlerSecretEditButtonClick = () => setEditMode(true)
  const handlerSecretRestoreButtonClick = () =>
    dispatch(pipelineDraft.actions.restoreSecret({id, name}))
  const handlerSecretConfirmEditButtonClick = (newName: string, value: string) => {
    dispatch(
      pipelineDraft.actions.renameSecret({
        id,
        name: newName,
        savedName: name,
      }),
    )

    if (value) {
      dispatch(
        pipelineDraft.actions.setSecret({
          id,
          name,
          value,
        }),
      )
    }

    setEditMode(false)
  }

  return {
    secretName,
    isEditMode,
    handlerSecretEditButtonClick,
    handlerSecretDeleteButtonClick,
    handlerSecretRestoreButtonClick,
    handlerSecretConfirmEditButtonClick,
  }
}

export default usePipelineSecret
